import { mergeProps } from '@zag-js/solid';
import { createUniqueId } from 'solid-js';
import { createSplitProps } from '../../utils/create-split-props';
import { ark } from '../factory';
import { useDatePickerContext } from './use-date-picker-context';
import { DatePickerTableProvider } from './use-date-picker-table-props-context';
import { useDatePickerViewContext } from './use-date-picker-view-props-context';
export const DatePickerTable = (props) => {
    const [{ columns }, localProps] = createSplitProps()(props, [
        'columns',
    ]);
    const api = useDatePickerContext();
    const viewProps = useDatePickerViewContext();
    const tableProps = { columns, id: createUniqueId(), ...viewProps };
    const mergedProps = mergeProps(() => api().getTableProps(tableProps), localProps);
    return (<DatePickerTableProvider value={tableProps}>
      <ark.table {...mergedProps}/>
    </DatePickerTableProvider>);
};
